const pt = {
    mask: {
        class: 'fixed inset-0 bg-black/40 backdrop-blur-sm z-modal-backdrop flex items-center justify-center p-4'
    },
    root: { class: 'bg-white rounded-12 shadow-e4 max-w-lg w-full max-h-[90vh] flex flex-col z-modal' },
    header: { class: 'flex items-center justify-between px-5 py-4 border-b border-gray-200' },
    title: { class: 'text-base font-semibold text-ink' },
    headerActions: { class: 'flex items-center gap-2' },
    closeButton: {
        class: 'w-8 h-8 rounded-6 flex items-center justify-center text-gray-400 hover:text-gray-700 hover:bg-gray-100'
    },
    content: { class: 'flex-1 overflow-y-auto px-5 py-4 text-sm text-gray-700' },
    footer: { class: 'flex items-center justify-end gap-2 px-5 py-4 border-t border-gray-200' }
}

export default pt
